var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-2",class:_vm.$vuetify.breakpoint.mdAndUp
      ? 'py-5 px-10'
      : '' && _vm.$vuetify.breakpoint.smAndUp
      ? 'py-2 px-2'
      : '',attrs:{"fluid":""}},[_c('pageHeader',{attrs:{"title":"Privacy Policy"}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.html)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }